import { FlashMessageService } from 'src/app/shared/services/flash-message.service';
import { CustomerService } from 'src/app/services/customer/customer.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { CurrentUserService } from 'src/app/core/services/current-user.service';
import { GoogleAnalyticsService } from 'src/app/shared/services/google-analytics/google-analytics.service';

@Component({
  selector: 'app-confirm-update',
  templateUrl: './confirm-update.component.html',
  styleUrls: ['./confirm-update.component.scss']
})
export class ConfirmUpdateCustomerComponent implements OnInit {
  public loading: boolean = false;
  private sub: any;
  private redirectUrl;
  public customerUserID: string;

  constructor(public customerService: CustomerService,
    public currentUserService: CurrentUserService,
    private flashMessageService: FlashMessageService,
    private route: ActivatedRoute,
    private router: Router,
    private _location: Location,
    private _gaSvc: GoogleAnalyticsService) { }

  ngOnInit() {
    if (!this.customerService.updatedCustomerUser.name) {
      this.router.navigate(['../../'], { relativeTo: this.route });
    }
    this.sub = this.route.queryParams.subscribe(params => {
      this.customerUserID = params['ID'];
      this.redirectUrl = params['urlPath'] ? params['urlPath'].split(`'`)[1] : null;
    })
    this.currentUserService.getUser().then(user => {});
  }

  get companyInfo(): { id: '', location: any, name: '' } {
    let customer: any = this.customerService.getCustomer(this.customerService.updatedCustomerUser.organization.organizationCode);
    if (customer) return customer;
  }

  confirm() {
    this.loading = true;
    this.customerService.updateCustomerUser(this.customerUserID)
      .then((response) => {
        this.customerService.resetCustomerUser();
        this.loading = false;
        this._gaSvc.register(`Admin updated a user`, this.currentUserService.user.organizationName);
        this.flashMessageService.updateMessage("Successfully updated user", 3000, "success");
        if (!this.redirectUrl) {
          this.router.navigate(['../../users'], { relativeTo: this.route });
        } else {
          this.router.navigate([`../../${this.redirectUrl}`], { relativeTo: this.route });
        }
      }).catch((error) => {
        this.loading = false;
        this.flashMessageService.updateMessage(error.message);
      });
  }

}
